/* import axios from 'axios' */
import {
    axiosJwt
} from '@/shared/auth/axios-lib'
import {
    errorHandler
} from '@/shared/errorHandler'

const api = `${process.env.VUE_APP_API_URL}${process.env.VUE_APP_API_PATH}`

export default {
    excluir(movimentacao) {
        return axiosJwt.delete(`${api}/contratos/${movimentacao.contratoId}/movimentacaominima/${movimentacao.movimentacaoMinimaId}`)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    inserir(movimentacao) {
        return axiosJwt.post(`${api}/contratos/${movimentacao.contratoId}/movimentacaominima`, movimentacao)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    atualizar(contratoId, movimentacaoMinimaId, movimentacao) {
        return axiosJwt.put(`${api}/contratos/${contratoId}/movimentacaominima/${movimentacaoMinimaId}`, movimentacao)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    obterMovimentacoes(contratoId) {
        return axiosJwt.get(`${api}/contratos/${contratoId}/movimentacaominima`)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    obterMovimentacao(contratoId, movimentacaoMinimaId) {
        return axiosJwt.get(`${api}/contratos/${contratoId}/movimentacaominima/${movimentacaoMinimaId}`)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    requisitarComprometimentoSaldoMovimentacao(movimentacaoMinimaId) {
        return axiosJwt.post(`${api}/contratos/requisicoes/requisitar-comprometimento-saldo-movimentacao-minima/${movimentacaoMinimaId}`)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            });
    }
}
